import { useLingui } from '@lingui/react/macro'
import { useGeckoLocale } from 'features/locale'
import { ToggleRadioGroup, ToggleRadioItem } from 'features/navbar/sharedStyles'
import React from 'react'
import styled from 'styled-components'
import { GeckoMeasurementSystem } from 'types'

const StyledContainer = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
`

/**
 *
 * @returns Toggle component to be used in the login dropdown (for now) for changing units used
 * across the app.
 */
export const UnitsToggle: React.FC = () => {
  const { measurementSystem, setMeasurementSystem } = useGeckoLocale()
  const { t } = useLingui()
  const labelId = React.useId()

  return (
    <StyledContainer>
      <span id={labelId}>{t`Units`}</span>
      <ToggleRadioGroup
        role='group'
        aria-labelledby={labelId}
        value={measurementSystem}
        onValueChange={(value) =>
          setMeasurementSystem(value as GeckoMeasurementSystem)
        }>
        <ToggleRadioItem
          value={GeckoMeasurementSystem.Imperial}
          aria-label={t`Change units to inches`}
          onSelect={(event) => event.preventDefault()}>
          in
        </ToggleRadioItem>
        <ToggleRadioItem
          value={GeckoMeasurementSystem.Metric}
          aria-label={t`Change units to millimeters`}
          onSelect={(event) => event.preventDefault()}>
          mm
        </ToggleRadioItem>
      </ToggleRadioGroup>
    </StyledContainer>
  )
}
